import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { AuthFormHeaderComponent } from '../../auth-form-header/auth-form-header.component';

const PROVIDER_ICONS: Record<string, string> = {
  GOOGLE: 'fab fa-google',
  MICROSOFT: 'fab fa-microsoft',
};

@Component({
  selector: 'mh-sso-step',
  standalone: true,
  imports: [SharedModule, AuthFormHeaderComponent],
  templateUrl: './sso-step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'tw-block' },
})
export class SsoStepComponent {
  readonly provider = input<string | null>(null);
  readonly email = input('');
  readonly noAccount = input(false);
  readonly loading = input(false);
  readonly errorKey = input<string | null>(null);

  readonly continueClicked = output<void>();
  readonly backClicked = output<void>();

  readonly providerLabel = computed(() => {
    const provider = this.provider();
    if (!provider) return '';
    return provider.charAt(0) + provider.slice(1).toLowerCase();
  });

  readonly providerIcon = computed(() => PROVIDER_ICONS[this.provider() ?? ''] ?? 'fas fa-building');
}
